import { Box, Divider, Stack, TextField, Typography } from '@mui/material';
import { BigNumber } from 'bignumber.js';
import { useState } from 'react';

import { CustomButton } from '@/shared/components/custom-button';
import CustomModal from '@/shared/components/custom-modal';

import { fmtAmount } from './formatters';
import { CoinModalProps } from './types';

export const SellModal = ({ open, onClose, coin }: CoinModalProps) => {
  const [amount, setAmount] = useState('');
  const handleClose = () => {
    setAmount('');
    onClose();
  };
  const estimatedUsd =
    coin.price != null && Number(amount) > 0 ? coin.price * Number(amount) : null;
  const exactAmount = new BigNumber(amount);
  const amountValid =
    exactAmount.isFinite() &&
    exactAmount.isGreaterThan(0) &&
    exactAmount.isLessThanOrEqualTo(coin.balance);

  return (
    <CustomModal
      open={open}
      onClose={handleClose}
      title={`Sell ${coin.symbol}`}
      withCloseButton
      sx={{ width: 420 }}
    >
      <Stack mt="16px" gap="20px" flexDirection="column">
        <Divider sx={{ borderColor: '#2E3348' }} />
        <Box bgcolor="#1E2333" border="1px solid #2E3348" borderRadius="10px" p="12px 16px">
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body3" color="text.secondary">
              Available
            </Typography>
            <Typography variant="body3">
              {fmtAmount(coin.balance)} {coin.symbol}
            </Typography>
          </Stack>
          {coin.price != null && (
            <Stack direction="row" justifyContent="space-between" mt="6px">
              <Typography variant="body3" color="text.secondary">
                Current price
              </Typography>
              <Typography variant="body3">${coin.price.toFixed(4)}</Typography>
            </Stack>
          )}
        </Box>
        <TextField
          label={`Amount to sell (${coin.symbol})`}
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          placeholder="0.00"
          type="number"
          fullWidth
          variant="outlined"
          size="small"
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
          slotProps={{
            input: {
              endAdornment: (
                <Typography
                  variant="body3"
                  color="success.main"
                  sx={{ cursor: 'pointer', fontWeight: 600, mr: '4px' }}
                  onClick={() => setAmount(coin.balance.toFixed())}
                >
                  MAX
                </Typography>
              ),
            },
          }}
        />
        {estimatedUsd != null && (
          <Typography variant="body3" color="text.secondary" textAlign="center">
            Estimated proceeds: <strong>${estimatedUsd.toFixed(2)} USD</strong>
          </Typography>
        )}
        <Stack gap="12px">
          <CustomButton
            disabled={!amountValid}
            sx={{
              background: '#F5841F',
              height: 44,
              borderRadius: '10px',
              ':disabled': { opacity: 0.3 },
            }}
            onClick={handleClose}
          >
            Sell {coin.symbol}
          </CustomButton>
          <CustomButton
            onClick={handleClose}
            sx={{ background: '#2A3040', borderRadius: '8px', height: 44 }}
          >
            Cancel
          </CustomButton>
        </Stack>
      </Stack>
    </CustomModal>
  );
};
